module.exports = __webpack_public_path__ + "img/sales3.1c802d1a.jpg";